import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { FormService } from 'src/app/services/form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ToastMessageService } from 'src/app/widgets/toast-message/toast-message.service';

@Component({
  selector: 'edit-inventory-adjustments-form',
  templateUrl: './edit-inventory-adjustments-form.component.html',
  styleUrls: ['./edit-inventory-adjustments-form.component.scss']
})
export class EditInventoryAdjustmentsFormComponent implements OnInit {

  // states
  formProcessing = false;
  isSubmitted = false;
  loading = true;

  // error messages
  fieldErrors: any = {};
  formErrors: any = null;

  // form
  form: UntypedFormGroup = this._fb.group({
    Id: [null],
    Code: [null, Validators.required],
    AdjustmentDescription: [null, Validators.required],
    UpdateGl: [false, Validators.required],
    StartDate: [this._utilsSvc.todaysDate],
    EndDate: [null]
  });;

  // data
  recordId: number;

  // endpoints
  private _endpoint: string;

  // subscriptions
  private _routeSub = null;

  constructor(
    private _apiSvc: ApiService,
    private _fb: UntypedFormBuilder,
    private _formSvc: FormService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _toastMsgSvc: ToastMessageService,
    private _utilsSvc: UtilitiesService
  ) { }

  ngOnInit() {

    this._endpoint = `${this._apiSvc.endpoints.inventory}/api/InventoryAdjustmentCode`;

    this._routeSub = this._route.params.subscribe((params: any) => {

      if (params.id) {
        this.recordId = params.id;
        this.getRecord(params.id);
      } else {
        this.loading = false;
      }

    });

  }

  ngOnDestroy() {

    if (this._routeSub) {
      this._routeSub.unsubscribe();
    }

  }

  /**
   * Update
   * @param res
   */
  updateFormValues(res: any): void {
    const patchValue = this._formSvc.getPatchValue(this.form.controls, res);
    this.form.patchValue(patchValue);
  }

  /**
   * Get record
   * @param id
   */
  getRecord(id: null): void {

    this._apiSvc.get(`${this._endpoint}/${id}`)
      .subscribe((res: any) => {
        this.updateFormValues(res);
        this.loading = false;
      }, (err: any) => {
        if (err.status === 404) {
          this._router.navigate(['/configuration/codes/inventory/adjustments']);
        }
      });

  }

  /**
   * Form submission event handler
   * @param e
   */
  onSubmit(e: any): void {

    e.preventDefault();

    this.isSubmitted = true;

    if (!this.form.valid || this.formProcessing) {
      return;
    }

    // clear errors
    this.formErrors = null;
    this.fieldErrors = {};

    this.formProcessing = true;

    const action = this.recordId ? 'update' : 'add';
    const ep = this.recordId ? `${this._endpoint}/${this.recordId}` : this._endpoint;

    // save the data
    this._apiSvc[action](ep, this.form.value)
      .subscribe(() => {

        this._toastMsgSvc.send({
          type: 'success',
          message: 'Inventory adjustment saved',
          icon: 'check_circle_outline'
        });

        if (!this.recordId) {
          this._router.navigate(['/configuration/codes/inventory/adjustments']);
        }

        this.formProcessing = false;

      }, (err) => {

        const errors = this._formSvc.processFormErrors(err);

        if (errors.formErrors) {
          this.formErrors = errors.formErrors;
        }

        if (errors.fieldErrors) {
          this.fieldErrors = errors.fieldErrors;
        }

        this.formProcessing = false;

      });

  }

}
